// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';

import {DNA_COMPLEMENT_TABLE} from 'biojs/BioConstants';
import * as util from 'biojs/Util';
import {CircularLayout} from 'molbio/maps/circular/CircularLayout';
import CircularMapView from 'molbio/maps/circular/CircularMap';
import Display from 'molbio/maps/circular/Display';
import {BUBBLE_WIDTH} from 'molbio/maps/InputBubble';
import {InputBubblePositionDetails} from 'molbio/maps/linear/InputBubbleView';
import {CircularMapState} from 'molbio/maps/MapStates';
import PolymerMapTabView from 'molbio/maps/PolymerMapTabView';
import SequenceMapUtil, {ShowInputBubbleOptions} from 'molbio/maps/SequenceMapUtil';
import CircularMapTabState from 'molbio/tabstates/CircularMapTabState';
import {MouseWheelEvent} from 'util/Mouse';

class CircularMapTab extends PolymerMapTabView<CircularMapTabState> {
  mapstate!: CircularMapState;
  circularMapView!: CircularMapView;
  layout!: CircularLayout;

  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-overflow';
    this.prototype.id = 'circular-map';
    this.prototype.inputSource = 'circular-input';
  }

  addPolymersForSearch(): void {
    SequenceMapUtil.addPolymersForSearch(this.model.get('sequence'));
  }

  removePolymersForSearch(): void {
    SequenceMapUtil.removePolymersForSearch(this.model.get('sequence'));
  }

  getHeight(): null {
    return null;
  }

  initialize(options: Backbone.ViewOptions<CircularMapTabState>): void {
    this.mapstate = this.model.get('mapstate');
    this.setMapDimensions();
    this.layout = this.mapstate.get('layout');
  }

  stopListening(): void {
    if (arguments.length === 0) {
      super.stopListening();
      d3.select(this.el).on('.circular', null);
      this.circularMapView?.die();
    } else {
      // Do not kill views/listeners when unmounting the input bubble
      // oxlint-disable-next-line prefer-rest-params
      super.stopListening(...arguments);
    }
  }

  isValidCharacter(char: string): boolean {
    return util.isValidBase(char, DNA_COMPLEMENT_TABLE);
  }

  showInputBubble(options: ShowInputBubbleOptions): void {
    SequenceMapUtil.showInputBubble(this, options);
  }

  storeRegionInBenchlingClipboard(e: JQueryEventObject): string {
    return SequenceMapUtil.maybeStoreNucleotideRegionInBenchlingClipboard(
      this.mapstate.get('sequence').selection(),
      e
    )!;
  }

  handlePasteText(text: string): void {
    SequenceMapUtil.handlePasteText(this.mapstate.get('sequence'), text);
  }

  handleCtrlShiftC(e: JQueryEventObject): void {
    SequenceMapUtil.handleCtrlShiftC(this.mapstate.get('sequence'), e);
  }

  handleArrowPress(e: JQueryEventObject): void {
    e.preventDefault();
    const selection = this.mapstate.get('sequence').get('selection');
    const shift = e.shiftKey;

    const start = selection.start();
    const end = selection.end();
    const length = this.mapstate.get('sequence').length();

    // oxlint-disable-next-line default-case
    switch (e.which) {
      case 37: // left arrow
        if (shift) {
          selection.circularExtendBy(-1);
        } else if (selection.isEmpty()) {
          selection.reset((start + length - 1) % length);
        } else {
          selection.reset(start);
        }
        break;
      case 39: // right arrow
        if (shift) {
          selection.circularExtendBy(1);
        } else if (selection.isEmpty()) {
          selection.reset((start + 1) % length);
        } else {
          selection.reset(end);
        }
        break;
    }

    this.mapstate.get('sequence').trigger('cursorJump');
  }

  // Returns null if the bubble cannot be rendered anymore (e.g., user scrolled it off screen)
  _calculateBubblePos(): InputBubblePositionDetails | null {
    const alignElement = this._getCursorElement();
    if (alignElement.length === 0) {
      return null;
    }

    let referenceOffset;
    let xFromReference;
    let yFromReference;
    const topPadding = 18;
    const parentOffset = this.$el.offset()!;
    const selection = this.getSelection();
    const alignElementAngle = this.circularMapView.getAngles(selection.start(), selection.end()).startAngle;

    // Calculate position of the bubble differently for circle, square and letter DNA views
    if (this.$el.find('.square').length > 0 || this.$el.find('.letter').length > 0) {
      const isSquaresView = this.$el.find('.square').length > 0;
      // Distance from the end of the cursor line outside of the circle to the inner edge of the circle
      const squaresDistance = 24;
      const lettersDistance = 36;
      const distance = isSquaresView ? squaresDistance : lettersDistance;
      referenceOffset = alignElement.offset()!;
      const quadrant = Math.floor(alignElementAngle / (Math.PI / 2)) + 1;
      // Uses the top left corner of the cursor line element and angle of the line from the center
      // to calculate where the line intersects the inner circle based on which quadrant the cursor is in.
      const selectionAngle = [3, 4].includes(quadrant) ? alignElementAngle + Math.PI : alignElementAngle;
      ({x: xFromReference, y: yFromReference} = Display.polar(distance, selectionAngle));
      yFromReference = [1, 3].includes(quadrant) ? -yFromReference : yFromReference;
    } else if (this.$el.find('.circle').length > 0) {
      const circleElement = this.$el.find('.circle');
      referenceOffset = circleElement.offset()!;
      const innerRadius = this.circularMapView.views.dnaView.getInnerRadius();
      const outerRadius = this.circularMapView.views.dnaView.getOuterRadius();
      ({x: xFromReference, y: yFromReference} = Display.polar(innerRadius, alignElementAngle));
      xFromReference += outerRadius;
      yFromReference += outerRadius;
    } else {
      return null;
    }
    let top = referenceOffset.top - parentOffset.top + topPadding + yFromReference;
    let left = referenceOffset.left - parentOffset.left + xFromReference;

    const width = this.$el.width() - left;
    let offset = 0;
    const endPadding = 20;
    if (width < BUBBLE_WIDTH - endPadding) {
      left = this.$el.width() - BUBBLE_WIDTH + endPadding;
      offset = BUBBLE_WIDTH - width - endPadding;
    }

    // Do not show bubble if the cursor/selection is off screen
    if (left < 0 || width < endPadding || top > this.$el.height() + topPadding) {
      return null;
    }

    // If user is inserting amino acids near bottom of page and bubble is going off the screen,
    // position the bubble above the slice
    const isPositionedAbove = this.allowBubblePositionedAboveSlice && top + 100 > this.$el.height();
    if (isPositionedAbove) {
      top -= 30;
    }

    return {top, left, offset, isPositionedAbove};
  }

  registerListeners(): void {
    this.stopListening();

    d3.select(this.el).on(`${MouseWheelEvent}.circular`, (e) => {
      const r = e.wheelDelta
        ? e.wheelDelta
        : e.detail
          ? e.detail * -40
          : e && e.wheelDelta
            ? e.wheelDelta
            : 0;

      if (e.ctrlKey) {
        if (r < 0) {
          this.mapstate.changeZoomByStep(r / 120);
        } else {
          this.mapstate.changeZoomByStep(r / 120);
        }
      } else {
        const steps = Math.ceil(Math.abs(((r / 60) * 10 * this.mapstate.get('sequence').length()) / 2000));
        const dir = r > 0 ? -1 : 1;
        this.mapstate.changePanByStep(dir * steps);
        this.circularMapView.updateSelection(e, 'mousemove');
      }
      this.repositionBubble();
      e.preventDefault();
    });

    this.listenTo(this.model.get('bufferViewLayout'), 'change:width change:height', () =>
      this.setMapDimensions()
    );
  }

  setMapDimensions(): CircularMapState {
    this.mapstate.set({width: this.model.get('bufferViewLayout')!.get('width')});
    return this.mapstate.set({height: this.model.get('bufferViewLayout')!.get('height')});
  }

  render(): this {
    super.render();
    this.registerListeners();
    // @ts-expect-error: unrecognized constructor arg types
    this.circularMapView = new CircularMapView({model: this.mapstate, tabstate: this.model});
    this.$el.append(this.circularMapView.render().el);
    return this;
  }
}
CircularMapTab.initClass();

export {CircularMapTab as CircularMapTabView};
